<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-Santa-Fe-2.webp',
                    '/pagesImages/Salon-Santa-Fe-1.webp',
                    '/pagesImages/instalaciones-Santa-Fe-1.webp',
                    '/pagesImages/Salon-Santa-Fe-2.webp',
                    '/pagesImages/biblioteca-Santa-Fe-1.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Santa-fe-r.webp",
                    "/pagesImages/encabezado-landing-Santa-fe-3.webp",
                ],
                altArray: [
                    "Universidad Humanitas Campus Ejecutivo Santa Fe",
                    "Universidad Humanitas Campus Ejecutivo Santa Fe",
                ],
                tour: [
                    { src:"/pagesImages/tour-Santa-Fe-1.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    { src:"/pagesImages/tour-Santa-Fe-2.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    // { src:"/pagesImages/tour-Santa-Fe-3.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    { src:"/pagesImages/tour-Santa-Fe-4.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    { src:"/pagesImages/tour-Santa-Fe-5.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    { src:"/pagesImages/tour-Santa-Fe-6.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                    { src:"/pagesImages/tour-Santa-Fe-7.webp", title:"Universidad Humanitas Campus Ejecutivo Santa Fe"},
                ],
                campusName: "SANTA FE",
                campusType: "CAMPUS EJECUTIVO",
                localidad: "CDMX",
                frase: "El conocimiento es el alimento del alma",
                autor: "Platón",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus ejecutivo'" :testo1="'Diseñado para los profesionales del futuro, es la referencia para quienes buscan excelencia académica, crecimiento profesional y una experiencia formativa diferenciadora.'" :testo2="'Ubicado en un quinto piso de un moderno edificio, el campus ofrece una vista panorámica espectacular de la ciudad, además de contar con un entorno inspirador que estimula el pensamiento estratégico, la creatividad y el espíritu emprendedor.'" :testo3="'Su modelo educativo está orientado a la especialización y aplicación real del conocimiento, lo cual, potencia oportunidades profesionales.'" :img="'/pagesImages/una-mirada-Santa-Fe.webp'" :alt="'Campus Ejecutivo Santa Fe'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Es ideal para quienes buscan diferenciarse en el mundo profesional. Ofrece<br class="lg:block hidden"> programas actualizados y un enfoque en la aplicación real del conocimiento.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras. Este espacio fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Oficinas ejecutivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Este campus simula escenarios reales del mundo corporativo con sesiones de mentoría, asesorías personalizadas y trabajo colaborativo.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Fotos de instalaciones de Campus Santa Fe"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        :alt="alts[currentImage2]"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Modernas instalaciones deportivas, como canchas de futbol rápido y baloncesto, equipadas con gradas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Ejecutivo Santa Fe</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: [ 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Contabilidad'],
    }" class="flex items-center justify-center" />
    <section class="flex w-full items-center justify-center text-gray-700 mt-10">
        <div class="flex flex-col w-full max-w-[1200px] justify-center items-center">
            <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
                <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
                    <img src="/pagesImages/landing-virtual-doctorado.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los diplomados">
                </div>
                <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2 items-center md:items-start">
                    <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-4 font-serif">Diplomados</p>
                    <ul class="text-left pl-6 space-y-1 list-disc">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Cognitivo Conductual</a>
                        </li>
                    </ul>
                    <br>
                </div>
            </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/vasos-cafe-despierta.webp" alt="Vasos de café de Despierta" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo Escolarizado</span>
                                </h3>
                                <p class="">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Ejecutivo Guadalajara en nuestro tour virtual.</p>
            <Instalaciones :items="tour" class="mb-8" />
            <!-- <iframe width="1140" height="641" src="https://www.youtube.com/embed/qBOIBjsj3RE" title="Campus Ejecutivo Santa Fe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        </div>
    </div>
	<Ubicacion :campus="'Campus Ejecutivo Santa Fe'" :mapa="'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.045101482417!2d-99.2634774!3d19.367199699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d200c4c7c35b35%3A0xab74b8d71b123e30!2sUniversidad%20Humanitas%20Campus%20Santa%20Fe!5e0!3m2!1ses-419!2smx!4v1747171145674!5m2!1ses-419!2smx'" :testo1="'Para llegar al campus en transporte público, es necesario dirigirse a las terminales del Sistema de Transporte Metro de la Ciudad de México, ya sea Tacubaya u Observatorio, y tomar una de las siguientes rutas: 9-C, 57, 76 o 300-B. También es posible utilizar la Línea 3 del Cablebús y descender en la estación Vasco de Quiroga.'" :testo2="'Para llegar en automóvil, se recomienda transitar por el Boulevard Adolfo López Mateos y continuar por la Avenida Constituyentes hasta la calle Guillermo González Camarena.'" :ubicacion="'Guillermo González Camarena 1900, PH, Santa Fe, Alcaldía Álvaro Obregón C.P. 01219, Ciudad de México.'" :telefono="'55-5292-2214'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
